module.exports = __webpack_public_path__ + "static/media/characterDesign2.5c003134.png";